import { useAppVersionStore } from '~/store/appVersion'

export default defineNuxtRouteMiddleware((to, from) => {
  const appVersionStore = useAppVersionStore()

  if(appVersionStore?.isChangeVersion) {
    return navigateTo(from.fullPath)
  }
})